import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Prismic from 'prismic-javascript';
import { RichText } from 'prismic-reactjs';
import { Link } from 'react-router-dom';

import Box from './box';

import LanguageContext from '../../context/LangContext';

const YellowBox = styled.span`
  a {
    background: #F1A857;
    color: #fff;
    display: flex;
    align-items: center;
    height: 192px;
    border-radius: 3px;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.3s;
    span {
      border-right: 1px solid #D99440;
      height: 100%;
      min-width: 118px;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        width: 80px;
        height: 80px;
        background-position: center;
        background-size: contain;
      }
    }
    &:hover {
      background: #E59134;
      span {
        border-right: 1px solid #CD8226;
      }
    }
    div {
      margin: 0 24px;
      strong {
        font: italic bold 30px 'Times new roman';
        display: block;
        margin-bottom: 20px;
      }
      p {
        font-size: 16px;
      }
    }
  }
`
const IconGlobe = styled.i`
  background: url(/images/streamline-icon-style-two-pin-world@140x140@2x.png) no-repeat center;
`

class SidebarContact extends Component {
  state = {
    items: [],
    language: '',
  }

  componentDidMount = () => {
    const { language } = this.context;
    this.setState({language: language});
    this.getContent();
  }

  componentDidUpdate = () => {
    const { language } = this.context;
    if (language !== this.state.language) {
      this.setState({language: language, items: []})
      this.getContent();
    }
  }

  getContent = () => {
    const { language } = this.context;
    const apiEndpoint = 'https://guararapes.cdn.prismic.io/api/v2'
    const Client = Prismic.client(apiEndpoint);

    const fetchData = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'barra_lateral_contato'),
        {lang: language}
      )
      if (response) {
        this.setState({items: response.results});
      }
    }
    fetchData();
  }

  render () {
    const { language } = this.context;
    let titleText = ''
    let textBox = ''
    switch (language) {
      case 'pt-br':
        titleText = 'Onde encontrar';
        textBox = 'Clique e saiba onde encontrar Guararapes';
        break;
      case 'en-us':
        titleText = 'Where to find';
        textBox = 'Click and know where to find Guararapes';
        break;
      case 'es-es':
        titleText = 'Donde encontrar';
        textBox = 'Haga clic y sepa dónde encontrar Guararapes';
        break;
      default:
    }
    return (
      <div>
        <YellowBox>
          <Link to="/onde-encontrar">
            <span>
              <IconGlobe />
            </span>
            <div>
              <strong>{ titleText }</strong>
              <p>
                { textBox }
              </p>
            </div>
          </Link>
        </YellowBox>
        {
          this.state.items.map((item, index) => {
            return (
              <Box key={ index } title={ item.data.nome[0].text }>
                { RichText.render(item.data.texto) }
              </Box>
            )
          })
        }
      </div>
    )
  }
}

SidebarContact.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

SidebarContact.contextType = LanguageContext;

export default SidebarContact;
